export default __webpack_public_path__ + "static/media/importante.1c0fe757.svg";